module.exports = __webpack_public_path__ + "static/media/video_1.e5bd6387.mp4";